import { Api, type InitApiClientOptions, initApi } from '.';
import { adminDashboardApiDeclaration } from './admin-dashboard-api';
import { adminsApiDeclaration } from './admins-api';
import { citiesApiDeclaration } from './cities-api';
import { cityAttractionsApiDeclaration } from './city-attractions-api';
import { cityCollectionsApiDeclaration } from './city-collections-api';
import { cityDistrictsApiDeclaration } from './city-districts-api';
import { cityEstablishmentsApiDeclaration } from './city-establishments-api';
import { cityFoodsApiDeclaration } from './city-foods-api';
import { cityExperienceReviewsApiDeclaration } from './city-experience-reviews-api';
import { cityPeopleApiDeclaration } from './city-people-api';
import { cityPlayerApiDeclaration } from './city-player-api';
import { cityPurchasesAdminApiDeclaration } from './city-purchases-admin-api';
import { cityQuestsApiDeclaration } from './city-quest-api';
import { cityQuestPlayApiDeclaration } from './city-quest-play-api';
import { cityReadyRoutesApiDeclaration } from './city-ready-routes-api';
import { contentReviewsApiDeclaration } from './content-reviews-api';
import { gygActivitiesApiDeclaration } from './gyg-activities-api';
import { partnersPortalAdminApiDeclaration } from './partners-portal-admin-api';
import { translationsApiDeclaration } from './translations-api';
import { uploadsApiDeclaration } from './uploads-api';

/**
 * Routellers client API — city quests / routes / partners contour only.
 */
export type InitApiDeclaration = {
    adminDashboardApi: Api<typeof adminDashboardApiDeclaration>;
    cityQuestsApi: Api<typeof cityQuestsApiDeclaration>;
    cityAttractionsApi: Api<typeof cityAttractionsApiDeclaration>;
    cityCollectionsApi: Api<typeof cityCollectionsApiDeclaration>;
    cityEstablishmentsApi: Api<typeof cityEstablishmentsApiDeclaration>;
    cityDistrictsApi: Api<typeof cityDistrictsApiDeclaration>;
    cityFoodsApi: Api<typeof cityFoodsApiDeclaration>;
    cityPeopleApi: Api<typeof cityPeopleApiDeclaration>;
    cityReadyRoutesApi: Api<typeof cityReadyRoutesApiDeclaration>;
    cityExperienceReviewsApi: Api<typeof cityExperienceReviewsApiDeclaration>;
    cityPurchasesAdminApi: Api<typeof cityPurchasesAdminApiDeclaration>;
    cityQuestPlayApi: Api<typeof cityQuestPlayApiDeclaration>;
    cityPlayerApi: Api<typeof cityPlayerApiDeclaration>;
    gygActivitiesApi: Api<typeof gygActivitiesApiDeclaration>;
    translationsApi: Api<typeof translationsApiDeclaration>;
    cities: Api<typeof citiesApiDeclaration>;
    admins: Api<typeof adminsApiDeclaration>;
    contentReviewsApi: Api<typeof contentReviewsApiDeclaration>;
    uploads: Api<typeof uploadsApiDeclaration>;
    partnersPortalAdminApi: Api<typeof partnersPortalAdminApiDeclaration>;
};

export const initClientApi = (
    url: string,
    clientOptions?: InitApiClientOptions,
): InitApiDeclaration => ({
    adminDashboardApi: initApi(adminDashboardApiDeclaration, url, clientOptions),
    cityQuestsApi: initApi(cityQuestsApiDeclaration, url, clientOptions),
    cityAttractionsApi: initApi(cityAttractionsApiDeclaration, url, clientOptions),
    cityCollectionsApi: initApi(cityCollectionsApiDeclaration, url, clientOptions),
    cityEstablishmentsApi: initApi(cityEstablishmentsApiDeclaration, url, clientOptions),
    cityDistrictsApi: initApi(cityDistrictsApiDeclaration, url, clientOptions),
    cityFoodsApi: initApi(cityFoodsApiDeclaration, url, clientOptions),
    cityPeopleApi: initApi(cityPeopleApiDeclaration, url, clientOptions),
    cityReadyRoutesApi: initApi(cityReadyRoutesApiDeclaration, url, clientOptions),
    cityExperienceReviewsApi: initApi(cityExperienceReviewsApiDeclaration, url, clientOptions),
    cityPurchasesAdminApi: initApi(cityPurchasesAdminApiDeclaration, url, clientOptions),
    cityQuestPlayApi: initApi(cityQuestPlayApiDeclaration, url, clientOptions),
    cityPlayerApi: initApi(cityPlayerApiDeclaration, url, clientOptions),
    gygActivitiesApi: initApi(gygActivitiesApiDeclaration, url, clientOptions),
    translationsApi: initApi(translationsApiDeclaration, url, clientOptions),
    cities: initApi(citiesApiDeclaration, url, clientOptions),
    admins: initApi(adminsApiDeclaration, url, clientOptions),
    contentReviewsApi: initApi(contentReviewsApiDeclaration, url, clientOptions),
    uploads: initApi(uploadsApiDeclaration, url, clientOptions),
    partnersPortalAdminApi: initApi(partnersPortalAdminApiDeclaration, url, clientOptions),
});
